import { Component } from '@angular/core';

@Component({
  selector: 'ngx-features-widget',
  templateUrl: './features-widget.component.html',
  styleUrls: ['./features-widget.component.scss']
})
export class FeaturesWidgetComponent {
  constructor(){}
}
